var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7015 11.3201L10.7605 12.3791L17.11 6.02962L18.1705 7.09012L10.7605 14.5001L5.9875 9.72712L7.048 8.66663L8.64175 10.2604L9.7015 11.3194V11.3201ZM9.703 9.19913L13.417 5.48438L14.4745 6.54187L10.7605 10.2566L9.703 9.19913ZM7.58275 13.4404L6.523 14.5001L1.75 9.72712L2.8105 8.66663L3.87025 9.72638L3.8695 9.72712L7.58275 13.4404Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/checkDouble.d1fdc09dffc13416623c346460029598.svg";
export { ForwardRef as ReactComponent };